import { SettingDefinition } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<SettingDefinition>({
  entityName: 'settingDefinition',
  collectionName: 'settingDefinitons'
})

export default actions
